import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  SURVEY_IDENTIFIER,
  SURVEY_LANGUAGE,
  SURVEY_NAME,
  SURVEY_VERSION
} from "../../../../ducks/survey";

import { filterSelected, TEMPLATE_LANGUAGES } from "../../../../ducks/surveySettings";

import { LANGUAGE_SELECTOR } from "../../../../common/constant";
import { LANGUAGE } from "../../../../ducks/languageSelector";
import {
  addQuestionToMyLibrary,
  addQuestionToTemplate,
  changeProperty,
  COL_SUBTYPE,
  getPrivateQuestionLibrary,
  MY_QUESTION_LIBRARY,
  QUESTION_NAME,
  QUESTION_TO_BE_ADDED,
  QUESTIONS_TO_ADD,
  SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY,
  SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS,
  SORT_TABLE_BY,
  SORT_TABLE_ORDER,
  sortColumn,
  submitAdding,
  SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY
} from "../../../../ducks/questionLibrary";
import { getQuestionsFromSurvey } from "../../../../ducks/surveyEditor";
import PrivateQuestionLibrarySurveyEditor from "./PrivateQuestionLibrarySurveyEditor";

const mapStateToProps = (state) => {
  return {
    surveyLanguage: state.survey[SURVEY_LANGUAGE],
    surveyName: state.survey[SURVEY_NAME],
    surveyIdentifier: state.survey[SURVEY_IDENTIFIER],
    surveyVersion: state.survey[SURVEY_VERSION],
    surveyQuestionIds: getQuestionsFromSurvey(state.surveyEditor)
      .filter(question => question.libraryQuestionId !== null)
      .map(question => question.libraryQuestionId),
    surveyLanguageForQuestionLibrary: state.questionLibrary[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY],
    showModalQuestionMyLibrarySettings: state.questionLibrary[SHOW_MODAL_QUESTION_MY_LIBRARY_SETTINGS],
    showModalAddQuestionFromLibrary: state.questionLibrary[SHOW_MODAL_ADD_QUESTION_FROM_OLD_LIBRARY],
    questionName: state.questionLibrary[QUESTION_NAME],
    questionLibrary: state.questionLibrary[MY_QUESTION_LIBRARY],
    templateLanguages: state.surveySettings[TEMPLATE_LANGUAGES],
    questionToBeAdded: state.questionLibrary[QUESTION_TO_BE_ADDED],
    questionsToAdd: state.questionLibrary[QUESTIONS_TO_ADD],
    sortTableBy: state.questionLibrary[SORT_TABLE_BY],
    sortTableOrder: state.questionLibrary[SORT_TABLE_ORDER],
    colSubtype: state.questionLibrary[COL_SUBTYPE],
    locale: state[LANGUAGE_SELECTOR][LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeProperty,
      filterSelected,
      addQuestionToMyLibrary,
      getPrivateQuestionLibrary,
      addQuestionToTemplate,
      submitAdding,
      sortColumn
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateQuestionLibrarySurveyEditor);
